export enum W4Type {
  Employer = "EMPLOYER",
  Federal = "FEDERAL",
  State = "STATE",
  Local = "LOCAL"
}

export enum W4UiType {
  Profile = "profile" ,
  NetPay = "netPay",
  Payee = "payee"
}